module.exports = __webpack_public_path__ + "assets/2e78d17dc3db8791afbc792de050a817.png";